import { Component, Input } from "@angular/core";

@Component({
	selector: "app-hero",
	standalone: true,
	templateUrl: "./hero.component.html",
	styleUrl: "./hero.component.scss",
})
export class HeroComponent {
	@Input() title = "";
	@Input() subtitle = "";
	@Input() imageDesktop = "";
	@Input() imageMobile = "";
}